import { Component, Vue, Inject } from 'vue-property-decorator';
import appconst from './appconst'
import Util from '@/lib/util'
export default class AbpBase extends Vue {
    L(value: string, source?: string, ...argus: string[]): string {
        if (source) {
            return window.abp.localization.localize(value, source, argus);
        } else {
            return window.abp.localization.localize(value, appconst.localization.defaultLocalizationSourceName, argus);
        }

    }
    hasPermission(permissionName: string) {
        return window.abp.auth.hasPermission(permissionName);
    }
    hasAnyOfPermissions(...argus: string[]) {
        return window.abp.auth.hasAnyOfPermissions(...argus);
    }
    hasAllOfPermissions(...argus: string[]) {
        return window.abp.auth.hasAllOfPermissions(...argus);
    }

    dateString(date, time = false) {
        return Util.formatTimeGMT(date, time)
    }

    get isEveProject() {
        let env =
        process.env.NODE_ENV === 'development'
            ? 'development'
            : process.env.VUE_APP_TITLE === 'alpha'
            ? 'alpha'
            : 'production'
        let eve = env === 'alpha' || process.env.NODE_ENV === 'development'
        return eve
    }

    get isVicutuProject() {
        // let env =
        // process.env.NODE_ENV === 'development'
        //     ? 'development'
        //     : process.env.VUE_APP_TITLE === 'alpha'
        //     ? 'alpha'
        //     : 'production'
        // let isVicutu = env === 'production' || process.env.NODE_ENV === 'development'
        // return isVicutu
        return false
    }

    get notRefundHandle() {
        let env =
        process.env.NODE_ENV === 'development'
            ? 'development'
            : process.env.VUE_APP_TITLE === 'alpha'
            ? 'alpha'
            : 'production'
        let eve = env === 'alpha'
        return eve
    }
}